function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

/* eslint arrow-body-style:0 */
const _ = require('lodash');

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

const CollectionLocalizerFactory = require('../entities/collection-localizer');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const Collection = require('../entities/collection');

const CollectionScores = require('../entities/collection-scores');

const CollectionUpdatePipeline = require('./collection-update-pipeline');

const filterQueries = require('../utils/filterQueries/filterQueries');

const {
  collectFilters
} = require('../utils/filterQueries/filterSetToQuery'); // const DAYS = 3600 * 24;


const DEFAULT_SCORES = {
  distance: [[0, 1], [1000000, 0]] // exclusive: [
  //   [0, 0],
  //   [1, 10]
  // ],
  // limited: [
  //   [0, 0],
  //   [1, 2]
  // ],
  // age: [
  //   [0, 0],
  //   [0, 10], // don't boost future offers because they might not be visible/discoverable
  //   [DAYS, 10],
  //   [DAYS, 7],
  //   [3 * DAYS, 7],
  //   [3 * DAYS, 5],
  //   [7 * DAYS, 5],
  //   [7 * DAYS, 0]
  // ]

};

const parseRegionFilters = collection => {
  const meta = collection.meta;
  const filterSet = {
    operator: 'and',
    filters: []
  };

  const includedRegions = _.get(meta, 'regions.included', []);

  if (includedRegions.length) {
    filterSet.filters.push({
      target: 'regions',
      operation: 'discoverableIn',
      args: includedRegions.map(id => ({
        id
      }))
    });
  }

  const excludedRegions = _.get(meta, 'regions.excluded', []);

  if (excludedRegions.length) {
    filterSet.filters.push({
      target: 'regions',
      operation: 'notDiscoverableIn',
      args: excludedRegions.map(id => ({
        id
      }))
    });
  }

  return filterSet;
};

const enrichRegionFilters = _async(function (regionFilters, client) {
  const elements = _.chain(regionFilters.filters).map(filter => filter.args).flatten().filter(Boolean).value();

  return _await(client.regions.multiDetails(elements.map(e => e.id)), function (regionDetails) {
    const regionDetailsMap = _.keyBy(regionDetails.items, 'id');

    elements.forEach(element => {
      /* eslint-disable-next-line no-param-reassign */
      element.label = regionDetailsMap[element.id].label;
    });
  });
});

const enrichFilter = _async(function (filter, client, context) {
  const filters = collectFilters(filter);
  if (!filters) return filter;
  const {
    propertyId
  } = context.serialize();
  const propertyRepo = client.properties.for(propertyId); // get Plans

  const plans = _.chain(filters).filter(({
    target
  }) => target === 'businessPolicyPlanId').map(f => f.args).flatten().value();

  return _await(Promise.all(plans.map(plan => {
    return propertyRepo.plans.for(plan.id).details().then(({
      name
    }) => {
      /* eslint-disable-next-line no-param-reassign */
      plan.name = name;
    });
  })), function () {
    // get Categories
    const categories = _.chain(filters).filter(({
      target
    }) => target === 'businessCategoryIds').map(f => f.args).flatten().value();

    return _await(Promise.all(categories.map(category => {
      return client.categories.details(category.id).then(({
        name
      }) => {
        /* eslint-disable-next-line no-param-reassign */
        category.name = name;
      });
    })), function () {
      return filter;
    });
  });
});

class CollectionEditBuilder {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  , collectionId
  /*: string*/
  ) {
    this.client = client;
    this.context = context;
    this.collectionId = collectionId;
    this.propertyRepo = this.client.properties.for(this.context.serialize().propertyId);
  }

  build()
  /*: Promise<CollectionUpdatePipeline>*/
  {
    const _this = this;

    return _call(function () {
      if (!_this.collectionId) return _await(_this.buildNew());
      const collectionEdit = new CollectionUpdatePipeline(_this.client, _this.context);
      return _await(_this.getCollection(), function (collection) {
        // Update localizable fields
        return _await(_this.getPropertyLocales(), function (locales) {
          return _await(_this.getLocalizations(), function (translations) {
            CollectionLocalizerFactory(locales).setLocalizations(collection, translations);
            collectionEdit.setInstance('collection', collection);
            collectionEdit.setInstance('locales', locales);
            return _await(_this.getCategories(collection.filterCategories), function (categories) {
              collectionEdit.setInstance('filterCategories', categories);
              const regionFilters = parseRegionFilters(collection);
              return _await(enrichRegionFilters(regionFilters, _this.client), function () {
                collectionEdit.setInstance('regionFilters', regionFilters); // Parse filters

                const businessFilter = filterQueries.queryToFilterSet(collection.businessFilter);
                return _await(enrichFilter(businessFilter, _this.client, _this.context), function () {
                  collectionEdit.setInstance('businessFilter', businessFilter);
                  const businessOfferFilter = filterQueries.queryToFilterSet(collection.businessOfferFilter);
                  return _await(enrichFilter(businessOfferFilter, _this.client, _this.context), function () {
                    collectionEdit.setInstance('businessOfferFilter', businessOfferFilter);
                    const _setInstance = collectionEdit.setInstance;
                    return _await(_this.getSchedules(collection.scheduleIds), function (_this$getSchedules) {
                      _setInstance.call(collectionEdit, 'schedules', _this$getSchedules);

                      // TODO: Remove tags since we can just bind directly to collection.filterTags
                      collectionEdit.setInstance('tags', collection.tags);
                      return collectionEdit;
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  buildNew()
  /*: Promise<CollectionUpdatePipeline>*/
  {
    const _this2 = this;

    return _call(function () {
      const collectionEdit = new CollectionUpdatePipeline(_this2.client, _this2.context);
      const collection = new Collection({
        scores: new CollectionScores(DEFAULT_SCORES)
      });
      return _await(_this2.getPropertyLocales(), function (locales) {
        CollectionLocalizerFactory(locales).setLocalizations(collection, []);
        collectionEdit.setInstance('collection', collection);
        collectionEdit.setInstance('locales', locales);
        collectionEdit.setInstance('filterCategories', []);
        collectionEdit.setInstance('tags', []);
        collectionEdit.setInstance('schedules', _this2.newSchedules());
        return collectionEdit;
      });
    });
  }

  getPropertyLocales()
  /*: Promise<Array<string>>*/
  {
    const _this3 = this;

    return _call(function () {
      return _await(_this3.propertyRepo.getLocales(), function (_this3$propertyRepo$g) {
        return _this3$propertyRepo$g.locales;
      });
    });
  }

  getLocalizations()
  /*: Promise<Array<{ locale: string, content: { [string]: string } }>>*/
  {
    const _this4 = this;

    return _call(function () {
      return _await(_this4.propertyRepo.collections.for(_this4.collectionId).getLocalizations(), function (_this4$propertyRepo$c) {
        return _this4$propertyRepo$c.items;
      });
    });
  }

  getCollection()
  /*: Promise<Collection>*/
  {
    return this.propertyRepo.collections.coreDetails(this.collectionId);
  }

  getCategories(categoryIds
  /*: Array<string>*/
  ) {
    return Promise.all(categoryIds.map(id => this.client.categories.details(id)));
  }

  getSchedules(scheduleIds
  /*: Array<string>*/
  ) {
    const _this5 = this;

    return _call(function () {
      return scheduleIds.length ? Promise.all(scheduleIds.map(id => _this5.client.schedules.for(id).details())) : _await(_this5.newSchedules());
    });
  }

  newSchedules() {
    return [this.client.schedules.initialize({
      type: 'discoverable',
      allDates: true
    })];
  }

}

module.exports = CollectionEditBuilder;